module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "A Personal Note / Tim Robinson"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Contents#rsec1"
    }
  }, [_vm._v("A PERSONAL NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "fmhs"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Contents#rsec1"
    }
  }, [_c('i', [_vm._v("Tim Robinson")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WHERE MIGHT ONE GLIMPSE SUCH")]), _vm._v(" a person as Myles of the Bees, who would chase a bee for a mile over bog and rocky hillside to find out its nest, or walk from his home on the coast to a remote mountain village in a similar search for sweetness, “looking for a kiss from a young woman”? Where might one hear the howls of English soldiers tricked into landing on an offshore island and left to die there by the outlawed priest they had just arrested? Or lend a hand to a fisherman’s wife walking home from Galway, a hard and hilly fifty miles, with the makings of a pair of oars, a boat’s sail, and its rigging tied on her back, all in a day? Or hear the desolate croak of the raven whose eggs had been stolen, hard-boiled, and replaced, and in whose nest was found “the stone of all gifts”? These beings’ sole existence in the 1930s, say, was in the fireside and turf bank talk of Iorras Aithneach, an Irish-speaking peninsula of south Connemara, and their persistence down to our own days is largely due to an amateur but gifted inquirer, Justice Seán Forde, who took down their stories from the best local "), _c('i', [_vm._v("seanchaithe")]), _vm._v(" or bearers of old lore. Seán Mac Giollarnáth, to give him his folkloric name, was wise enough not to try to improve or correct his sources’ Irish, but recorded it in all its countryside pungency and directness. When I was making my map of Connemara in the 1990s, and later in the writing of "), _c('i', [_vm._v("Connemara: A Little Gaelic Kingdom")]), _vm._v(", I found his book "), _c('i', [_vm._v("Annála Beaga ó Iorras Aithneach")]), _vm._v(" such a trove of placelore that I vowed to repay my debt to it by republication, translation, and annotation. The one failing of the original is due to the fact that Mac Giollarnáth did most of his research in the bar of Mongan’s Hotel in Carna, so that the location of the score of little coves, rocks, and hillocks named in it were not recorded. However, when I was exploring the area in detail, I inquired out most of them and can add that extra dimension to the matter through maps and notes.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "images/fxii-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Figure 1 Seán Mac Giollarnáth (1880–1970) and Sgeolán. © Bailiúchán Mhic Giollarnáth / Ford Family Collection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("So, here at last is the fulfilment of that promise, made possible by the labors of Liam Mac Con Iomaire, who prepared "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("an Irish version of the original in modernized spelling, taking care to preserve the dialectal tang of Connemara Irish, which he had listened to from his zeroth birthday as it were. Then he undertook an English version, which we kicked to and fro between the two of us until it seemed to us as close to the original text as the impossible art of translation allows. We dedicate the result to the Irish talkers of Connemara. May their voices never be silenced.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("But what manner of man was this predecessor whose footprints I found waiting for me in the bogs of Connemara? A vague, thrown away observation of some village historian tells us that Justice Forde had been known to impose a just fine on a brewer of poitín or netter of salmon, and then, knowing that the like of such money was not to be had in the cottages, pay the fine himself. I feel I can trust this man as a sure-footed guide on quaggy bog and razor-edged granite. He is for me a figure of justice, even of Justice with a capital "), _c('i', [_vm._v("J")]), _vm._v("."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("TR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86338cb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253063526_Frontmatter03.vue
// module id = 78
// module chunks = 0